import React, { createContext, useContext, useState, useEffect } from 'react';
import { languageAPI } from '../services/api';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLanguages();
  }, []);

  const loadLanguages = async () => {
    try {
      const response = await languageAPI.getLanguages();
      setAvailableLanguages(response.languages);
    } catch (error) {
      console.error('Failed to load languages:', error);
      // Fallback languages with flags
      setAvailableLanguages([
        { code: 'en', name: 'English', flag: '🇬🇧' },
        { code: 'tr', name: 'Türkçe', flag: '🇹🇷' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const changeLanguage = (lang) => {
    console.log('🌍 LanguageContext: Changing language from', language, 'to', lang);
    
    // Only change if different
    if (lang === language) {
      console.log('🌍 LanguageContext: Same language, skipping');
      return;
    }
    
    setLanguage(lang);
    localStorage.setItem('language', lang);
    console.log('🌍 LanguageContext: Language changed successfully');
  };

  const value = {
    language,
    availableLanguages,
    loading,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

